import { FormPropertyProps } from "../../FormProperty";
import { GroupMultivalued } from "./GroupMultivalued";
import { GroupSimple } from "./GroupSimple";

export const Group = (props: FormPropertyProps) => {
    const GroupComponent = props.property.multivalue ? GroupMultivalued : GroupSimple;

    return <GroupComponent {...props} />;
};
